import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Divider,
    Grid,
    IconButton,
    Paper,
    Snackbar,
    Tooltip,
    Typography
} from "@mui/material";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import ReactPlayer from "react-player";
import {Layer, Map, Marker, Source} from "@vis.gl/react-maplibre";
import httpReq from "../../services/httpReq";
import {useEffect, useMemo, useRef, useState} from "react";
import FullPageLoader from "../loaders/FullPageLoader";
import PinDropIcon from "@mui/icons-material/PinDrop";
import {useForm} from "react-hook-form";
import {msg} from "@lingui/macro";
import {useLingui} from "@lingui/react";
import * as lod from "lodash";
import {getAsiaUserFromLocalStorage} from "../../session/getAsiaUser";
import Tags from "../modals/asiaProjects/components/Tags";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import HomeMadeDialog from "../dialogs/HomeMadeDialog";
import {AddAPhoto, Topic, Videocam} from "@mui/icons-material";
import {httpReqBlob} from "../../services/httpReqBlob";
import FormAddReport from "./FormAddReport";
import RightReportsListMenu from "./ReportListMenu";
import ReportAttachmentsList from "./ReportAttachmentsList";
import {BASE_URL} from "../../consts/BaseUrl";
import * as turf from '@turf/turf'

const VideoComponent = ({mapStyle, setMapStyle, mapKey, selectedVideo, isMobile, reportId}) => {
    const user = getAsiaUserFromLocalStorage()
    const mapRef = useRef(null);
    const playerRef = useRef(null);
    const videoElementRef = useRef(null);
    const hasSeekedRef = useRef(false)
    const playerContainerRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);
    const [videoPauseTime, setVideoPauseTime] = useState(null)
    const [reportMenuIsOpen, setReportMenuIsOpen] = useState(false)
    const [reportAttachmentsIsOpen, setReportAttachmentsIsOpen] = useState(false)

    const [isLoading, setIsLoading] = useState(false)
    const [selectedVideoReport, setSelectedVideoReport] = useState(null)
    const [tagsList, setTagsList] = useState([])
    const [selectedTags, setSelectedTags] = useState([])
    const [isLoadingTracks, setIsLoadingTracks] = useState(false)
    const [tracks, setTracks] = useState([])
    const [locations, setLocations] = useState([])
    const [isLocationsLoading, setIsLocationsLoading] = useState(false)
    const [markerPosition, setMarkerPosition] = useState(null)
    const [isPlaying, setIsPlaying] = useState(false);
    const liveTrackingSecondsSpan = 1;
    const liveTrackingPositions = 30;
    //
    const [isOpenReportTypeDialog, setIsOpenReportTypeDialog] = useState(false);
    const [pageMessage, setPageMessage] = useState(null);
    const [pointToPointStartTime, setPointToPointStartTime] = useState(null);

    const {control, formState, getValues, reset} = useForm({
        mode: 'onChange',
        defaultValues: {
            description: selectedVideoReport?.description || '',
            title: selectedVideoReport?.title || ''
        }
    })
    const {_} = useLingui()


    const [isOpenDialogSelectedReport, setIsOpenDialogSelectedReport] = useState(false)

    const calculateTrackDistance = (points) => {
        if (!points || points.length < 2) return 0;
        const line = turf.lineString(points.map(p => [p.longitude, p.latitude]));
        const km = turf.length(line, {units: "kilometers"});
        return km * 1000
    };


    const getSectionDistance = (track) => {
        if (!track?.points) return 0;
        return calculateTrackDistance(track.points);
    };


    const deleteReport = async (report) => {
        setIsLoading(true)
        const r = report ? report : selectedVideoReport
        const res = await httpReq(`Report/Delete/${r.id}`, 'DELETE', null, true)
        if (!res.responseAnyError) {
            // getVideoReports()
            setIsLoading(false)
        }
    }

    const getTagsList = async () => {
        const res = await httpReq('Tag/GetList', 'GET', null, true)
        if (!res.responseAnyError) {
            const data = res.responseData
            const dt = lod.sortBy(data, ['orderIndex'], 'desc')
            const a = dt.map(data => {
                data.isOpen = false
                return data
            })
            setTagsList(a)
        }
    }

    const getReportTagsList = async () => {
        setIsLoading(true)
        const res = await httpReq(`ReportTagValue/GetList/${selectedVideoReport.id}`, 'GET', null, true)
        const responseData = res.responseData || []

        const requests = responseData.map(dt => {
            return httpReq('TagValue/Get/' + dt.tagValue.id, 'GET', null, true)
        })

        const responses = await Promise.all(requests)

        const tags = responses
            .filter(r => !r.responseAnyError)
            .map(r => {
                const data = r.responseData
                if (data.fileContent && data.fileContent !== '') {
                    const fileExtension = data.fileExtension.split('.')
                    const base64 = `data:${data.fileMimeType}/${fileExtension[1]};base64,${data.fileContent}`
                    data.base64 = base64
                }
                return data
            })

        setSelectedTags(tags)
        setIsLoading(false)
    }

    useEffect(() => {
        if (locations && locations.length > 5) return;
        if (isLocationsLoading) return;
        if (!isPlaying) return;
        setIsLocationsLoading(true);
        const currentVideoPLayTime = playerRef?.current?.getCurrentTime() ?? 0;
        const payload = {
            initPlayTime: currentVideoPLayTime,
            secondsSpan: liveTrackingSecondsSpan,
            offset: liveTrackingPositions
        }
        httpReq('/Video/GetPlayLocations/' + selectedVideo.id, 'POST', payload, true)
            .then((res) => {
                if (res.responseAnyError) return;
                setLocations([...locations, ...res.responseData]);
                setIsLocationsLoading(false)
            })
    }, [isPlaying, isLocationsLoading, locations, selectedVideo.id]);

    useEffect(() => {
        const timer = setInterval(() => {
            if (!isPlaying) return;
            const currentVideoPLayTime = playerRef?.current?.getCurrentTime() ?? 0;
            const endVideoPlayTimeToFind = currentVideoPLayTime + liveTrackingSecondsSpan;
            const maxLocationTime = currentVideoPLayTime + (liveTrackingSecondsSpan * liveTrackingPositions);
            const foundLocation = locations.find(loc => loc.playTime >= currentVideoPLayTime && loc.playTime < endVideoPlayTimeToFind);
            if (foundLocation) {
                setMarkerPosition({
                    longitude: foundLocation.longitude,
                    latitude: foundLocation.latitude
                })
                mapRef.current.flyTo({
                    essential: true,
                    center: [foundLocation.longitude, foundLocation.latitude],
                    zoom: 20
                })
            }
            const newLocations = locations.filter(loc => loc.playTime >= currentVideoPLayTime && loc.playTime < maxLocationTime);
            setLocations(newLocations);
        }, 1000);
        return () => {
            clearInterval(timer);
        };
    }, [isPlaying, locations]);

    useEffect(() => {
        setIsLoadingTracks(true)
        httpReq('Video/GetTracks/' + selectedVideo.id, 'GET', null, true)
            .then((res) => {
                if (res.responseAnyError) return;
                setTracks(res.responseData);
            })
            .finally(() => setIsLoadingTracks(false));
    }, [selectedVideo]);

    useEffect(() => {
        const handleWheel = (e) => {
            if (!isHovered) return;

            const player = playerRef.current;
            if (!player) return;

            const currentTime = player.getCurrentTime();
            const delta = e.deltaY;
            const step = 1; // seconds per scroll step

            const newTime = delta > 0 ? currentTime + step : currentTime - step;
            player.seekTo(Math.max(0, newTime), 'seconds');
        };

        const container = playerContainerRef.current;
        if (container) {
            container.addEventListener('wheel', handleWheel, {passive: true});
        }

        return () => {
            if (container) {
                container.removeEventListener('wheel', handleWheel);
            }
        };
    }, [isHovered]);

    const downloadBlob = (blob, fileName) => {
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    const handleScreenshot = () => {
        setIsLoading(true);
        const playTime = playerRef?.current.getCurrentTime();
        httpReqBlob('/Video/ExtractFrame/' + selectedVideo.id, 'POST', {
            playTime: playTime,
        }, true).then((blob) => {
            if (!blob) return;
            setIsLoading(false);
            const fileName = selectedVideo.title + '_' + playTime + ".jpg"
            downloadBlob(blob, fileName);

        })
    }

    const addTagValueToNewReport = async (tag, value) => {
        const n = [...selectedTags]
        value.tag = tag
        if (!tag.isMultiple) {
            const filtered = n.filter(value => value.tag.id !== tag.id)
            filtered.push(value)
            setSelectedTags(filtered)
        } else {
            const idx = n.findIndex(v => v.id === value.id)
            if (idx > -1) {
                const dt = {
                    reportFk: selectedVideoReport.id,
                    tagValueFk: value.id
                }
                await httpReq('ReportTagValue/Delete', 'DELETE', dt, true)
                n.splice(idx, 1);
            } else {
                n.push(value)
            }
            setSelectedTags(n)
        }

    }

    const getVideoReports = async (reportId = null) => {
        const res = await httpReq(`Report/GetList`, 'POST', {
            pageIndex: 0,
            pageSize: 0,
            videoFk: selectedVideo.id,
            tagValuesFk: []
        }, true)

        if (!res.responseAnyError) {

            // setVideoReports(res.responseData)
            if (reportId) {
                const foundedReport = res.responseData.find(report => {
                    return report.id === +reportId
                })
                setSelectedVideoReport(foundedReport)
            }
        }
    }

    useEffect(() => {

        getTagsList()
        if (selectedVideoReport) {
            getReportTagsList()
            reset({
                title: selectedVideoReport?.title,
                description: selectedVideoReport?.description,
            })
            playerRef.current.seekTo(selectedVideoReport.beginPlayTime);
        }

    }, [selectedVideoReport])

    useEffect(() => {
        if (selectedVideo && selectedVideo.coords) {
            setSelectedVideoReport(null)
            setTimeout(() => {
                mapRef.current.flyTo({
                    essential: true,
                    center: [selectedVideo.coords.coordinates[0], selectedVideo.coords.coordinates[1]],
                    zoom: 15
                })
            }, 1000)
        }
    }, [selectedVideo]);

    useEffect(() => {
        if (reportId) {
            getVideoReports(reportId)
        }
    }, [reportId]);


    const handlePauseVideo = () => {

        const currentTime = playerRef.current?.getCurrentTime()
        setIsPlaying(false);
        setVideoPauseTime(currentTime)

        if (pointToPointStartTime !== null) {

            createNewReport(currentTime);

            setPointToPointStartTime(null);
            setPageMessage(null);
        }
    }

    const handlePlay = () => {
        setIsPlaying(true);
        setVideoPauseTime(null);
    }

    const handleOpenMenu = () => {
        setIsLoading(true)
        getVideoReports()
        setReportMenuIsOpen(!reportMenuIsOpen)
        setIsLoading(false)
    }


    const createNewReport = async (endPoint = null) => {
        setIsLoading(true)
        let body = null;
        if (!endPoint) {
            body = {
                id: 0,
                title: '',
                description: '',
                videoFk: selectedVideo.id,
                reporterFk: user.id,
                managerFk: 0,
                beginPlayTime: videoPauseTime,
                beginLongitude: 0,
                beginLatitude: 0
            }
        } else {
            let distanceKm = 0
            if (tracks.length > 0) {
                distanceKm = getSectionDistance(tracks[0])
                console.log('distanceKm ----> ', distanceKm)
            }
            body = {
                id: 0,
                title: '',
                description: '',
                videoFk: selectedVideo.id,
                reporterFk: user.id,
                managerFk: 0,
                beginPlayTime: pointToPointStartTime,
                beginLongitude: 0,
                beginLatitude: 0,
                endPlayTime: endPoint,
                endLongitude: 0,
                sectionLength: distanceKm,
                endLatitude: 0
            }
        }

        console.log('bodyyyy ', body)
        const res = await httpReq('Report/Insert', 'POST', body, true)
        if (!res.responseAnyError) {
            setIsLoading(false)
            console.log('report insert responseData ', res.responseData)
            setSelectedVideoReport(res.responseData)
        }
    }

    const addReportToVideo = async () => {
        setIsLoading(true)
        const formValues = getValues()
        const dataToSend = {
            id: selectedVideoReport ? selectedVideoReport.id : 0,
            title: formValues.title,
            description: formValues.description,
            videoFk: selectedVideo ? selectedVideo.id : selectedVideoReport.video.id,
            reporterFk: user.id,
            managerFk: 0,
            beginPlayTime: selectedVideoReport.beginPlayTime || videoPauseTime,
            beginLongitude: 0,
            sectionLength: selectedVideoReport.sectionLength,
            beginLatitude: 0,
            endPlayTime: selectedVideoReport.endPlayTime,
            endLongitude: 0,
            endLatitude: 0,
        }
        const resReport = await httpReq('Report/Update', 'PATCH', dataToSend, true)

        const prom = selectedTags.map(async value => {
            const dataToSend = {
                tagValueFk: value.id,
                reportFk: selectedVideoReport ? selectedVideoReport.id : resReport.responseData.id
            }
            const res = await httpReq('ReportTagValue/Insert', 'POST', dataToSend, true)
            return res
        })
        await Promise.all(prom)
        setSelectedVideoReport(null)
        setIsLoading(false)

    }

    const visibleTracks = useMemo(() => {

        if (tracks.length === 0) return <></>

        return (
            <>
                {tracks.map(track => {
                        const sourceID = 'tracks-source-' + track.id;
                        const trackLayer = {
                            id: 'track-layer-' + track.id,
                            type: 'line',
                            source: sourceID,
                            'layout': {
                                'line-join': 'round',
                                'line-cap': 'round'
                            },
                            paint: {
                                'line-color': selectedVideo.color || 'red',
                                'line-width': 2
                            }
                        };
                        const points = track.points.map((point) => {
                            return [point.longitude, point.latitude]
                        });
                        track.geoJSON = {
                            id: track.id,
                            type: 'Feature',
                            properties: {track: {...track}},
                            geometry: {
                                type: 'LineString',
                                coordinates: [...points]
                            },
                        };
                        track.layer = trackLayer;
                        return (
                            <Source
                                key={'key-' + track.layer.id}
                                id={track.layer.id}
                                type={'geojson'}
                                data={track.geoJSON}
                            >
                                <Layer {...track.layer} />
                            </Source>
                        )
                    }
                )}
            </>
        )
    }, [selectedVideo.color, tracks]);

    const locationsPoints = useMemo(() => {

        if (locations.length === 0) return <></>

        const features = locations.map((location) => {
            return (
                {type: 'Feature', geometry: {type: 'Point', coordinates: [location.longitude, location.latitude]}}
            )
        })
        const geojson = {
            type: 'FeatureCollection',
            features: [...features]
        };
        const layerStyle = {
            id: 'point',
            type: 'circle',
            paint: {
                'circle-radius': 5,
                'circle-color': selectedVideo.color || 'blue'
            }
        };
        return (
            <Source id="locations-source" type="geojson" data={geojson}>
                <Layer {...layerStyle} />
            </Source>
        )
    }, [locations]);

    const locationMarker = useMemo(() => {

        if (!markerPosition) return <></>
        return <Marker longitude={markerPosition.longitude} latitude={markerPosition.latitude}/>
    }, [markerPosition]);

    const NewReportMarker = () => {

        return (

            <>
                selectedVideoReport.endLongitude ?
                <>
                    <Marker longitude={selectedVideoReport.beginLongitude}
                            latitude={selectedVideoReport.beginLatitude}/>
                    <Marker longitude={selectedVideoReport.endLongitude} latitude={selectedVideoReport.endLatitude}>
                        <div
                            style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                backgroundColor: "red",
                                border: "2px solid white"
                            }}
                        />
                    </Marker>
                </>
                :
                <Marker longitude={selectedVideoReport.beginLongitude} latitude={selectedVideoReport.beginLatitude}/>
            </>

        )
    }

    const manageCloseReport = () => {
        const values = getValues()
        const title = values.title
        const description = values.description
        if (!title && !description) {
            setIsOpenDialogSelectedReport(true)
        } else {
            setSelectedVideoReport(null)
        }
    }

    return (
        <>
            <Card
                sx={{
                    borderRadius: 4,
                    boxShadow: 3,
                    bgcolor: 'background.default',
                    width: '100%',
                    height: '90vh',
                    borderRight: '1px solid lightgray',
                    mt: 2
                }}
            >
                <CardContent
                    sx={{
                        height: '100%',
                        overflowY: 'auto'
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        minHeight: '40px'
                    }}>
                        <Typography variant="h6"
                                    sx={{fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 4}}>
                            <Videocam/> {selectedVideo.title}
                        </Typography>
                        <Typography variant={'subtitle2'}>{selectedVideo.description}</Typography>
                    </Box>
                    <Divider sx={{mb: 2}}/>
                    <Grid container sx={{mt: 3}} spacing={1}>
                        <Grid item xs={12} lg={selectedVideoReport ? 6 : 9} sx={{pr: 2, position: 'relative'}}>
                            <Box
                                ref={playerContainerRef}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                sx={{height: selectedVideoReport ? '45vh' : '70vh'}}
                            >
                                <ReactPlayer
                                    width="100%"
                                    height="100%"
                                    url={`${BASE_URL}/Video/Play/${selectedVideo.id}`}
                                    playing={false}
                                    muted
                                    ref={playerRef}
                                    onReady={() => {
                                        if (selectedVideoReport && !hasSeekedRef.current) {
                                            playerRef.current.seekTo(selectedVideoReport.beginPlayTime);
                                            hasSeekedRef.current = true;
                                        }
                                    }}
                                    controls
                                    onPlay={handlePlay}
                                    onPause={handlePauseVideo}
                                />
                                <video ref={videoElementRef} crossOrigin="anonymous" style={{display: 'none'}}/>
                            </Box>
                            <Tooltip title={_(msg`Create report`)}>
                                <Button
                                    disabled={isPlaying || selectedVideoReport}
                                    onClick={() => setIsOpenReportTypeDialog(true)}
                                    sx={{
                                        position: 'absolute',
                                        left: 10,
                                        top: -10,
                                        borderRadius: 4,
                                        zIndex: 100
                                    }} variant="contained"
                                >
                                    {<PinDropIcon/>}
                                </Button>
                            </Tooltip>
                            <Tooltip title={_(msg`Report list`)}>
                                <Button
                                    disabled={isPlaying || selectedVideoReport}
                                    onClick={() => handleOpenMenu()}
                                    sx={{
                                        position: 'absolute',
                                        left: 80,
                                        top: -10,
                                        borderRadius: 4,
                                        zIndex: 100
                                    }}
                                    variant="contained"
                                >
                                    <FormatListBulletedIcon/>
                                </Button>
                            </Tooltip>
                            <Tooltip title={_(msg`Save screenshoot`)}>
                                <Button
                                    disabled={isPlaying}
                                    variant={'contained'}
                                    sx={{
                                        position: 'absolute',
                                        left: 150,
                                        top: -10,
                                        borderRadius: 4,
                                        zIndex: 100
                                    }}
                                    onClick={() => handleScreenshot()}>
                                    <AddAPhoto/>
                                </Button>
                            </Tooltip>
                            <Tooltip title={_(msg`Attachments list`)}>
                                <Button
                                    disabled={!selectedVideoReport}
                                    variant={'contained'}
                                    sx={{
                                        position: 'absolute',
                                        left: 220,
                                        top: -10,
                                        borderRadius: 4,
                                        zIndex: 100
                                    }}
                                    onClick={() => {
                                        setReportAttachmentsIsOpen(true)
                                    }}>
                                    <Topic/>
                                </Button>
                            </Tooltip>

                        </Grid>
                        <Grid item xs={12} lg={3} sx={{position: 'relative', p: 1}}>
                            <Map
                                initialViewState={{
                                    latitude: selectedVideo.latitude,
                                    longitude: selectedVideo.longitude,
                                    zoom: 4,
                                }}
                                ref={mapRef}
                                mapStyle={`https://api.maptiler.com/maps/${mapStyle}/style.json?key=${mapKey}`}
                            >
                                {tracks && tracks.length > 0 && visibleTracks}
                                {isPlaying && locations && locations.length > 0 && locationsPoints}
                                {isPlaying && markerPosition && locationMarker}
                                {selectedVideoReport && <NewReportMarker/>}

                            </Map>
                            {isLoadingTracks && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(255,255,255,0.7)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 10,
                                    }}
                                >
                                    <CircularProgress/>
                                </Box>
                            )}
                            {selectedVideoReport?.sectionLength > 0 && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 10,
                                        right: 10,
                                        bgcolor: 'rgba(255,255,255,0.8)',
                                        color: 'black',
                                        px: 2,
                                        py: 1,
                                        borderRadius: 3,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '0.9rem',
                                        boxShadow: 2,
                                        backdropFilter: 'blur(4px)',
                                        zIndex: 20,
                                    }}
                                >
                                    {selectedVideoReport.sectionLength >= 1000
                                        ? `${(selectedVideoReport.sectionLength / 1000).toFixed(1)} km`
                                        : `${Math.round(selectedVideoReport.sectionLength)} m`}
                                </Box>
                            )}

                        </Grid>
                        {selectedVideoReport && (
                            <>
                                <Grid item xs={12} lg={3} sx={{p: 1}}>
                                    <Paper elevation={3}
                                           sx={{padding: 3, borderRadius: 3, width: '100%', height: '100%'}}>
                                        <Box sx={{display: 'flex', flexDirection: 'row', gap: 1}}>
                                            <Chip color="primary" icon={<PinDropIcon/>}
                                                  label={selectedVideoReport?.beginLatitude.toFixed(6)}></Chip>
                                            <Chip color="primary" icon={<PinDropIcon/>}
                                                  label={selectedVideoReport?.beginLongitude.toFixed(6)}></Chip>
                                            <Box sx={{
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'flex-end'
                                            }}>
                                                <Tooltip title={'Save report'}>
                                                    <IconButton disabled={!formState.isValid} onClick={() => {
                                                        addReportToVideo()
                                                    }}><SaveIcon/></IconButton>
                                                </Tooltip>
                                                <Tooltip title={'Close report'}>
                                                    <IconButton
                                                        onClick={() => {
                                                            manageCloseReport()
                                                        }}><CloseIcon/></IconButton>
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                        <Box>
                                            {/**
                                             <TooltipButton title={'Save report'} icon={<SaveIcon/>} action={() => addReportToVideo()}/>
                                             <TooltipButton title={'Close report'} icon={<CloseIcon/>} action={() => setSelectedVideoReport(null)}/>
                                             **/}
                                            <FormAddReport isMobile={isMobile} control={control}/>
                                        </Box>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12}>
                                    <Tags projectId={selectedVideo.project.id} selectedTags={selectedTags}
                                          addTagValueToNewReport={addTagValueToNewReport}/>
                                </Grid>
                            </>
                        )}

                    </Grid>
                </CardContent>
            </Card>
            <RightReportsListMenu reportId={reportId} setSelectedVideoReport={setSelectedVideoReport}
                                  setIsOpen={setReportMenuIsOpen} selectedVideo={selectedVideo}
                                  isOpen={reportMenuIsOpen}/>
            {selectedVideoReport &&
                <ReportAttachmentsList selectedVideoReport={selectedVideoReport} isOpen={reportAttachmentsIsOpen}
                                       setIsOpen={setReportAttachmentsIsOpen}/>
            }
            {isLoading && <FullPageLoader/>}
            {isOpenDialogSelectedReport && <HomeMadeDialog
                isOpen={isOpenDialogSelectedReport}
                labelClose={'Cancel'}
                labelConfirm={'Confirm'}
                text={_(msg`Delete report?`)}
                fnClose={() => {
                    setSelectedVideoReport(null)
                    setIsOpenDialogSelectedReport(false)
                }}
                fnConfirmAction={() => deleteReport().then(() => {
                    setIsOpenDialogSelectedReport(false);
                    setSelectedVideoReport(null)
                })}
                title={`Title and description are empty`}/>}
            {isOpenReportTypeDialog && (
                <HomeMadeDialog
                    isOpen={isOpenReportTypeDialog}
                    title={_(msg`Report type`)}
                    text={_(msg`Do you want to create a single or a road section report?`)}
                    fnClose={() => setIsOpenReportTypeDialog(false)}
                    hideDefaultButtons
                    customActions={(
                        <>
                            <Button
                                variant="outlined"
                                color="inherit"
                                onClick={() => setIsOpenReportTypeDialog(false)}
                            >
                                {_(msg`Close`)}
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setIsOpenReportTypeDialog(false);
                                    createNewReport();
                                }}
                            >
                                {_(msg`Single point`)}
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    const currentVideoPlayTime = playerRef?.current?.getCurrentTime() ?? 0;
                                    setPageMessage(_(msg`Pause the video to create the road section report`))
                                    setPointToPointStartTime(currentVideoPlayTime);
                                    setIsOpenReportTypeDialog(false);

                                    playerRef.current?.getInternalPlayer()?.play();
                                }}
                            >
                                {_(msg`Road section`)}
                            </Button>
                        </>
                    )}

                />
            )}
            {pageMessage && (
                <Snackbar
                    open
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    onClose={() => setPageMessage(null)}
                >
                    <Alert severity="info" sx={{width: '100%'}}>
                        {pageMessage}
                    </Alert>
                </Snackbar>
            )}
        </>
    )
}
export default VideoComponent;